import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getnotificationAPi, deletenotificationApi, deleteallnotificationApi } from "../../../ApiUrl";
export const token = sessionStorage.getItem("accessToken")

const headers = {
    Authorization: `Bearer ${token}`,
};

// get notification
export const getnotification = createAsyncThunk('getnotification/notification', async () => {
    try {
        const response = await axios.get(`${getnotificationAPi}?limit=`, { headers });
        return response.data;
    } catch (error) {
        throw new Error(error.message);
    }
});

// delete notification
export const deletenotifications = createAsyncThunk('deletenotifications/notification', async (notificationid, { rejectWithValue }) => {
    try {
        const response = await axios.delete(`${deletenotificationApi}/${notificationid}`, { headers });
        return response.data._id; // Assuming your API response contains a 'notificationid' property
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
});
// all delete
export const deleteallnotifications = createAsyncThunk(
    'deleteallnotifications/notification',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.delete(deleteallnotificationApi, { headers }); // Ensure headers are defined somewhere
            return response.data.message;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Unknown error occurred');
        }
    }
);



const notificationSlice = createSlice({
    name: 'notification',
    initialState: {
        notifications: [],
        status: 'idle',
        error: null,
        message: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            //getnotifications
            .addCase(getnotification.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getnotification.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.notifications = action.payload;
            })
            .addCase(getnotification.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            //delete notifications
            .addCase(deletenotifications.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deletenotifications.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.notifications.data = state.notifications.data.filter(notifications => notifications.notificationid !== action.payload);
                state.status = 'idle'
            })
            .addCase(deletenotifications.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })
            //delete all notifications
            .addCase(deleteallnotifications.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteallnotifications.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status = 'succeeded') {
                    alert(action.payload)
                }
                state.status = 'idle'
            })
            .addCase(deleteallnotifications.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status = 'failed') {
                    alert(action.payload)
                }
            });
    }
});

export default notificationSlice.reducer;
